import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["toggle", "form"];

  toggleVisibility() {
    this.formTarget.classList.toggle("hidden")
  }
}